// extracted by mini-css-extract-plugin
export default {"root":"SideBlock_root__GMn5X","titleAll":"SideBlock_titleAll__x9Fg6","title":"SideBlock_title__o4mpY"};